import { HttpInterceptorFn } from '@angular/common/http';
import { inject, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

export const languageHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LOCALE_ID); // Angular locale (build or provided)
  const platformId = inject(PLATFORM_ID);

  let activeLang = locale;

  // If running in the browser, prefer the <html lang=""> attribute if present
  if (isPlatformBrowser(platformId)) {
    const doc = inject(DOCUMENT);
    const htmlLang = doc?.documentElement?.lang;
    if (htmlLang) {
      activeLang = htmlLang;
    }
  }

  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': activeLang,
    },
  });

  return next(cloned);
};
